// Node Modules
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { nanoid } from 'nanoid';
import { RichText } from 'prismic-reactjs';

// Themes
import theme from '@/themes/index';

export const Highlights = ({
  content: {
    title,
    locationFounded,
    location,
    climate,
    additionalInformation,
    images,
  } = {},
}) => (
  <>
    <div className='highlights-container'>
      <h6>{title}</h6>
      <div className='content'>
        <i>
          <FontAwesomeIcon icon={['fa', 'calendar']} />
        </i>
        <p className='title'>Site Founded:</p>
        <p>{locationFounded}</p>
      </div>
      <div className='content'>
        <i>
          <FontAwesomeIcon icon={['fa', 'map-marker']} />
        </i>
        <p className='title'>Location:</p>
        <p>{location}</p>
      </div>
      <div className='content'>
        <i>
          <FontAwesomeIcon icon={['fa', 'sun']} />
        </i>
        <p className='title'>Climate:</p>
        <p>{climate}</p>
      </div>
      <RichText render={additionalInformation} />
      <div className='images-container'>
        {images?.map(item => (
          <a href={item.imageUrl ? item.imageUrl.url : null} key={nanoid()}><img  src={item?.image?.url} /></a>
        ))}
      </div>
      
    </div>
    <style jsx>{`
      h6,
      p {
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0;
        margin-inline-end: 0;
      }

      div.highlights-container {
        display: flex;
        flex-direction: column;
      }

      h6 {
        font-family: ${theme.fontFamilies.montserratBold};
        padding-bottom: 1rem;
      }

      div.content {
        display: flex;
        flex-direction: row;
        padding-bottom: 0.8rem;
        align-items: baseline;
        gap: 0.8rem;
        text-align: justify;
      }

      p.title {
        font-family: ${theme.fontFamilies.openSansBold};
      }

      p.additional-information {
        padding-top: 0.5rem;
      }

      .images-container {
        display: flex;
        padding-top: 2.9rem;
        gap: 1.6rem;
        align-items: center;
        width: 100%;
        flex-direction: column;
      }

      img {
        width: 100%;
        max-width: 13.9rem;
        height: 7.5rem;
      }

      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        .images-container {
          justify-content: flex-start;
          flex-direction: row;
        }
      }
    `}</style>
  </>
);

export default Highlights;
